import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 400px;
`;

export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 35vh;
  margin-top: 10px;
  overflow: auto;
`;

export const UserItem = styled.div`
  display: flex;
  flex-direction: row;
  padding: 5px;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.tableBackground};
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.containerOdd};
  }
  & .user-group-item-remove {
    margin-left: auto;
  }
`;

export const UserInfoText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: 0 10px;
  overflow: hidden;
  & h4 {
    margin: 0;
    font-size: 14px;
  }
  & span {
    font-size: 9px;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    &.email {
      font-size: 12px;
    }
  }
`;
